var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestimonialIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.37257 0 0 5.37257 0 12C0 18.6274 5.37257 23.9999 12 23.9999C18.6274 23.9999 23.9999 18.6274 23.9999 12C23.9929 5.37554 18.6245 0.00708147 12 0ZM17.0536 12.3823C16.9706 12.549 16.8355 12.6841 16.6688 12.7671V12.7714L9.8117 16.2C9.38822 16.4116 8.87343 16.2399 8.66179 15.8164C8.60162 15.696 8.57063 15.5631 8.57139 15.4286V8.57144C8.57119 8.09804 8.95474 7.71413 9.42815 7.71388C9.56129 7.71383 9.69262 7.74477 9.8117 7.80428L16.6688 11.2329C17.0925 11.444 17.2648 11.9586 17.0536 12.3823Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestimonialIcon);
export default __webpack_public_path__ + "static/media/testimonial_icon.6ca724c95b462ed574c5af75c9de5c57.svg";
export { ForwardRef as ReactComponent };